var exports = {
  "xE": "WarningAlert.module__alert___N2ZUMW",
  "Kk": "WarningAlert.module__icon___N2ZUMW",
  "Qs": "WarningAlert.module__content___N2ZUMW",
  "DD": "WarningAlert.module__title___N2ZUMW",
  "Qq": "WarningAlert.module__text___N2ZUMW",
  "nf": "WarningAlert.module__link___N2ZUMW",
  "o1": "WarningAlert.module__actions___N2ZUMW",
};

module.exports = exports;
